import classes from "./AboutUs.module.css";
import AboutImage from "../../img/resume-image.jpg";

// Icons
import PhoneIcon from "../../img/phone-icon.svg";
import MailIcon from "../../img/email-icon.svg";
import HomeIcon from "../../img/home-icon.svg";
import LinkedinIcon from "../../img/linkedin-icon.svg";
import FacebookIcon from "../../img/facebook-icon.svg";
import InstagramIcon from "../../img/instagram-icon.svg";
import SEO from "../../seo/SEO";

export default function AboutUs() {
  return (
    <div className={`container ${classes.about}`}>
      <SEO
        title={"Χαλντούν Σόρτογλου | Βιογραφικό"}
        description={
          "Ο δικηγόρος Χαλντούν Σόρτογλου, με δικαστική εμπειρία σε ποινικό, αστικό, διοικητικό δίκαιο, έχει τρία μεταπτυχιακά και είναι υποψήφιος διδάκτορας στο Αστικό Δίκαιο, μιλώντας Τουρκικά, Αγγλικά, Γερμανικά."
        }
      />
      <div className={classes.description}>
        <h2>
          ΧΑΛΝΤΟΥΝ <br />
          ΣΟΡΤΟΓΛΟΥ
        </h2>
        <p>
          Δικηγόρος και μέλος του Δικηγορικού Συλλόγου Ροδόπης. Ασκεί το
          λειτούργημά του έχοντας παραστάσεις σε δικαστήρια όλης της επικράτειας
          σε υποθέσεις ποινικού, αστικού και διοικητικό δικαίου.{" "}
        </p>
        <p>
          Το έτος 2014 αποφοίτησε από τη Νομική Σχολή του Δημοκριτείου
          Πανεπιστημίου Θράκης. Στη συνέχεια, πραγματοποίησε μεταπτυχιακές
          σπουδές και πλέον είναι κάτοχος τριών μεταπτυχιακών διπλωμάτων από
          διαφορετικά πανεπιστήμια. Το έτος 2018 έλαβε μεταπτυχιακό δίπλωμα
          ειδίκευσης με τον βαθμό «Άριστα» από τον Τομέα Ιδιωτικού Δίκαιου με
          κατεύθυνση Αστικού Δίκαιου της Νομικής Σχολής του Δημοκριτείου
          Πανεπιστημίου Θράκης. Το έτος 2021 έλαβε μεταπτυχιακό δίπλωμα από το
          Οικονομικό Πανεπιστήμιο Αθηνών (Τμήμα Διεθνών Οικονομικών Σπουδών) με
          αντικείμενο τις διεθνείς διαπραγματεύσεις («Μ.Sc. International
          Negotiations»). Tέλος, το έτος 2023 του απενεμήθη μεταπτυχιακό δίπλωμα
          ειδίκευσης από τον Τομέα Δημοσίου Δικαίου και Πολιτικής Επιστήμης με
          κατεύθυνση Διοικητικού Δικαίου της Νομικής Σχολής του Δημοκριτείου
          Πανεπιστημίου Θράκης. Σήμερα είναι Υποψήφιος Διδάκτορας στην ανωτέρω
          σχολή με αντικείμενο το Αστικό Δίκαιο. Γνωρίζει Τουρκικά, Αγγλικά και
          Γερμανικά.
        </p>
      </div>
      <div className={classes["image-box"]}>
        <img src={AboutImage} alt="Χαλντούν Σόρτογλου" />
      </div>
      <div className={classes.contact}>
        <div className={classes["contact-box"]}>
          <img src={PhoneIcon} />
          <a href="tel:+302531554466">2531554466</a>
          <a href="tel:+306907450126">6907450126</a>
        </div>
        <div className={classes["contact-box"]}>
          <img src={MailIcon} />
          <a href="mailto:h.sortoglou@gmail.com">h.sortoglou@gmail.com</a>
        </div>
        <div className={classes["contact-box"]}>
          <img src={HomeIcon} />
          <a href="https://goo.gl/maps/oedQY6toQoTohhB48" target="_blank">
            Α. Παπαδήμα 22 <br />
            Κομοτηνή
          </a>
        </div>
        <div className={classes["contact-box"]}>
          <a href="https://gr.linkedin.com/in/haldun-sortoglou" target="_blank">
            <img src={LinkedinIcon} />
          </a>
          <a href="https://www.facebook.com/haldun.sortoglou" target="_blank">
            <img src={FacebookIcon} />
          </a>
          <a href="https://www.instagram.com/haldunsortoglou" target="_blank">
            <img src={InstagramIcon} />
          </a>
        </div>
      </div>
      {/* <div className={classes['justice-box']}>
                <h3>ΠΟΛΙΤΙΚΗ<br/> ΔΙΚΑΙΟΣΥΝΗ</h3>
                <p>Παράσταση ενώπιον των Πρωτοδικείων Αθηνών, Θεσσαλονίκης, Ρόδου, Θηβών, Έδεσσας, Δράμας, Χαλκιδικής, Ξάνθης, Ροδόπης, Αλεξανδρούπολης, Ορεστιάδας,  Ενδεικτικά για υποθέσεις ενοχικού δικαίου, ανακοπές, ασφαλιστικά μέτρα, συντηρητική κατάσχεση, αυτοκινητιστικά ατυχήματα, οικογενειακού δικαίου, εμπραγμάτου δικαίου. Έκδοση διαταγών πληρωμής από αξιόγραφα. Εκπροσώπηση εταιριών,  παροχή γνωμοδοτήσεων νομιμοποίησης. Επιβολή κατάσχεσης για λογαριασμό προσωπικών εταιριών. Εφέσεις κατά αποφάσεων Ειρηνοδικείων και Πρωτοδικείων.</p>
            </div>
            <div className={classes['justice-box']}>
                <h3>ΔΙΟΙΚΗΤΙΚΗ<br/> ΔΙΚΑΙΟΣΥΝΗ</h3>
                <p>Παράσταση ενώπιον του Διοικητικού Εφετείου Αθηνών, Θεσσαλονίκης και Κομοτηνής για υποθέσεις ουσίας και ακυρωτικών διαφορών. Διοικητικού Πρωτοδικείου Αθηνών, Κομοτηνής, Ρόδου, Αλεξανδρούπολης για υποθέσεις αγορανομικών προστίμων, αλλοδαπών, απαλλοτριώσεων, Αποζημιώσεων 105 ΕισΝΑΚ. Αναίρεση κατά αποφάσεων Διοικητικών Εφετείων. Εκπροσώπηση ιδιωτών και ΝΠΔΔ,  ΟΤΑ και παροχή σε αυτούς γνωμοδοτήσεων.</p>
            </div>
            <div className={classes['justice-box']}>
                <h3>ΠΟΙΝΙΚΗ<br/> ΔΙΚΑΙΟΣΥΝΗ</h3>
                <p>Παράσταση ενώπιον των Εφετείων Κακουργημάτων, Αθηνών, Θεσσαλονίκης, Βορείου Αιγαίου, Θράκης, Δωδεκάνησου και Πατρών σε συνθέσεις Μονομελούς, Τριμελούς και Πενταμελούς για εγκλήματα κατά της περιουσίας, ιδιοκτησίας, νόμου περί ναρκωτικών, οικονομικά εγκλήματα και παραβάσεις του νόμου περί αλλοδαπών Παράσταση στις ανακριτικές αρχές των Πρωτοδικείων Ζακύνθου, Ρόδου, Μυτιλήνης, Κομοτηνής, Αθηνών, Ορεστιάδας, Θεσσαλονίκης, Έδεσσας, Δράμας. Σύνταξη αναίρεσης ενώπιον του Αρείου Πάγου.</p>
            </div> */}
    </div>
  );
}
